import { tokens } from "@/shared/design-system/tokens";
import styled from "@emotion/styled";

export const TabsContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  border-bottom: 1px solid white;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border-radius: 8px 8px 0 0;
  overflow: hidden;
`;

export const Tab = styled.button<{ active?: boolean }>`
  width: 100%;
  height: 53px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 24px;
  border: none;
  border-radius: 0 0 0 0;
  background: ${(props) =>
  props.active ? `${tokens.colors.blue[900]}` : `${tokens.colors.transparencies[0]}`};
  backdrop-filter: ${(props) => (props.active ? "" : "blur(10px)")};
  color: ${tokens.colors.basics[0]};
  font-size: 14px;
  font-weight: 600;
  cursor: ${(props) => (props.active ? "default" : "pointer")};
  transition: all 0.2s ease;
  position: relative;

  &:focus {
    outline: none;
  }

  &::selection {
    border: none;
  }

  &:not(:disabled):hover {
    background: ${(props) =>
      props.active ? "#0B3E5F" : "rgba(11, 62, 95, 0.1)"};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;
